import React, { useEffect, useRef, useState } from "react";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import { useDispatch, useSelector } from "react-redux";
import { getCandidatefromcategory } from "../../../../redux/cv/action";
import { useNavigate } from "react-router-dom";
import PostNotFound from "../../../CustomComponents/AllLoader/PostNotFound";
import { getPostStingName } from "../../../../assests/extention/commonfunction";
import OTSSearch from "../../../Common/Search/OTSSearch";
import { useAllFilterBaseContext } from "../../../../Context/AllFilterBaseContext";

export default function SearchDownloadCV() {
  const path = "Assets/scss/FindWork.module.scss";
  const dispatch = useDispatch();
  const laung = localStorage.getItem("laung");
  const [lan] = useState(laung ?? "en");
  const { state, setSearch } = useAllFilterBaseContext();
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState(null);

  const cvcc = useSelector(
    ({ cv: { getcvcandidatelistcategory } }) => getcvcandidatelistcategory
  );

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  useEffect(() => {
    dispatch(getCandidatefromcategory(state.search));
  }, [state.search]);

  useEffect(() => {
    if (Array.isArray(cvcc) && cvcc.length > 0) {
      setSelectedCategory(cvcc[0]);
    }
  }, [cvcc]);

  const handleCategorySelect = (category) => {
    setSelectedCategory(selectedCategory === category ? null : category);
  };

  const handleImageError = (e) => {
    e.target.src = `${CloudStorage.cloudurl}/Assets/Images/hireexpert/expert-1.svg`;
  };


  const navigatetofilerhire = (ind, cat) => {
    const data = {
      industry_id: ind?.id,
      industry_name: ind?.title,
      category_id: cat?.id,
      category_name: cat?.title,
    };
    navigate(`/${lan}/searchdownloadcvbycategory`, {
      state: { indcatsub: data },
    });
  };

  return (
    <div className="project-section">
      <div className="col-md-12 project1">
        <div className="col-md-5 mx-auto">
          <h2 className="font-42">
            Elevate Your Hiring Game. Access Top Talent with Ease!
          </h2>

          <OTSSearch
            state={state}
            setSearch={setSearch}
            placeholder={`Search ${getPostStingName("9")}`}
          />
        </div>
      </div>

      {/* CATEGORY LIST */}
      {Array.isArray(cvcc) && cvcc.length > 0 ? (
        <div className="col-lg-8 mx-auto category-filter">
          <h2>Choose an industry to filter candidates</h2>

          <div id="accordion" className="accordion-sec-filter">
            {cvcc.map((item, index) => (
              <div className="accordion-sec" key={index}>
                <a
                  className={`card-link ${selectedCategory === item ? "active" : ""
                    }`}
                  onClick={() => handleCategorySelect(item)}
                >
                  {item?.title}
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/common/nav-icon.svg`}
                    onError={handleImageError}
                    alt=""
                    style={{
                      transition: "transform 0.3s ease",
                      transform:
                        selectedCategory === item
                          ? "rotate(180deg)"
                          : "rotate(0deg)",
                    }}
                  />
                </a>

                <div
                  className={`collapse ${selectedCategory === item ? "show" : ""
                    }`}
                >
                  <div className="row collapse-row">
                    {selectedCategory === item &&
                      item.category?.map((cat, idx) => (
                        <div
                          className="col-md-4"
                          key={idx}
                          onClick={() => navigatetofilerhire(item, cat)}
                        >
                          <div className="create-project1">
                            <h4>{cat?.title}</h4>
                            <h6>{cat?.expert_count} experts</h6>
                            <div className="task-img">
                              <img
                                src={cat?.image}
                                onError={handleImageError}
                                alt={cat?.title}
                              />
                            </div>
                          </div>
                        </div>
                      ))}

                    {selectedCategory === item &&
                      item.category?.length === 0 && (
                        <PostNotFound title="Skills are not found" />
                      )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="col-lg-8 mx-auto category-filter">
          <h2>No results found</h2>
        </div>
      )}
    </div>
  );
}
